import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    padding: '2em',
    backgroundColor: theme.palette.grey[200],
    width: '100%'
  },
  paper: {
    padding: '1em',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)'
  },
  loading: { height: '100vh' },
  buttonSubmit: {
    backgroundColor: theme.palette.success.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    }
  },
  buttonReset: {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main
  },
  chipInput: {
    '& p': {
      color: theme.palette.info.main,
      fontStyle: 'italic'
    }
  }
}))